
	import { defineComponent, PropType } from 'vue';
	import { JsonData, JsonDataType, SelectedJsonData } from '@/types';

	export default /*#__PURE__*/defineComponent({
		name: 'json-view-item',
		data() {
			return {
				open: this.data.depth < this.maxDepth
			};
		},
		props   : {
			data     : {
				required: true,
				type    : Object as PropType<JsonData>
			},
			maxDepth : {
				type    : Number,
				required: false,
				default : 1
			},
			canSelect: {
				type    : Boolean,
				required: false,
				default : false
			}
		},
		emits   : [ 'update:selected' ],
		methods : {
			emitSelect(data: JsonData): void {
				this.$emit('update:selected', {
					key  : data.key,
					value: data.type === JsonDataType.VALUE ? data.value : undefined,
					path : data.path
				} as SelectedJsonData);
			},
			bubbleSelected(data: SelectedJsonData): void {
				this.$emit('update:selected', data);
			},
			getKey(value: any): string {
				if (!isNaN(value.key)) {
					return value.key + ':';
				} else {
					return '"' + value.key + '":';
				}
			},
			getValueStyle(value: any): object {
				switch (typeof value) {
					case 'string':
						return { color: 'var(--vjc-string-color)' };
					case 'number':
						return { color: 'var(--vjc-number-color)' };
					case 'boolean':
						return { color: 'var(--vjc-boolean-color)' };
					case 'object':
						return { color: 'var(--vjc-null-color)' };
					case 'undefined':
						return { color: 'var(--vjc-null-color)' };
					default:
						return { color: 'var(--vjc-valueKey-color)' };
				}
			}
		},
		computed: {
			lengthString(): string {
				switch (this.data.type) {
					case JsonDataType.ARRAY:
						return this.data.length === 1
							? this.data.length + ' element'
							: this.data.length + ' elements';
					case JsonDataType.OBJECT:
						return this.data.length === 1
							? this.data.length + ' property'
							: this.data.length + ' properties';
					default:
						return '';
				}
			},
			dataValue(): string {
				if (this.data.type === JsonDataType.VALUE) {
					if (typeof this.data.value === 'undefined') {
						return 'undefined';
					}
					return JSON.stringify(this.data.value);
				}
				return '';
			}
		}
	});
